module.exports = __webpack_public_path__ + "media/images/pages/portefolio-62df53ee562005da2f522fad776695d8.jpg";